export default __webpack_public_path__ + "static/media/customer-journey-path.acf0bb80.gif";